module.exports = __webpack_public_path__ + "img/ic_colada.4f3a6126.svg";